import { checkIsValidPeriod } from "./private/checkIsValidPeriod";
import { checkIsMovable } from "./private/checkIsMovable";

// サブスクで更新停止ボタンを表示するかどうか
export const checkIsSubscribable = (masterBook, book) => {
  return (masterBook.mode == "subscription" &&
    checkIsValidPeriod(book) && checkIsMovable(book) &&
    book.is_continue
  );
}